module.exports = __webpack_public_path__ + "img/server-down.5e1a9d3d.png";